module.exports = __webpack_public_path__ + "media/images/site/erik-white-full-26b820d16ccd979f11106a1ef24cdbac.png";